import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { DAY_LABELS, addDays, iso, overlapsDay, toneClass } from "./helpers";

const Chip = ({ ev }) => {
  const inner = (
    <>
      <div className="truncate text-[11px] font-semibold leading-tight">{ev.title}</div>
      <div className="truncate text-[10px] opacity-75">{ev.sub}</div>
    </>
  );
  const cls = `block w-full rounded border px-1.5 py-1 text-left transition-transform duration-150 hover:-translate-y-px ${toneClass(ev.tone)}`;
  return ev.link ? (
    <Link to={ev.link} className={cls} data-testid={`cal-event-${ev.key}`}>{inner}</Link>
  ) : (
    <div className={cls} data-testid={`cal-event-${ev.key}`}>{inner}</div>
  );
};

export const MonthView = ({ anchor, events, totalUnits, onPickDay, onQuickAdd }) => {
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const lead = (first.getDay() + 6) % 7;
  const gridStart = addDays(first, -lead);
  const cells = Array.from({ length: 42 }, (_, i) => addDays(gridStart, i));
  const today = iso(new Date());

  return (
    <div data-testid="calendar-month-view">
      <div className="grid grid-cols-7 gap-1 sm:gap-2">
        {DAY_LABELS.map((d) => (
          <div key={d} className="pb-1 text-center text-[10px] uppercase tracking-widest text-ink-soft">{d}</div>
        ))}
        {cells.map((d) => {
          const day = iso(d);
          const items = events.filter((e) => overlapsDay(e, day));
          const busy = items.reduce((a, e) => a + (e.qty || 1), 0);
          const other = d.getMonth() !== anchor.getMonth();
          return (
            <div key={day} data-testid={`cal-day-${day}`}
              className={`group relative min-h-[92px] rounded-lg border p-1.5 sm:min-h-[124px] sm:p-2 ${
                other ? "border-black/5 bg-cream-dark/40" : "border-black/10 bg-white"} ${
                day === today ? "ring-2 ring-lm-red/60" : ""}`}>
              <div className="flex items-baseline justify-between">
                <button onClick={() => onPickDay(d)} data-testid={`cal-open-day-${day}`}
                  className={`text-xs font-semibold ${other ? "text-ink-soft/60" : "text-ink"} hover:text-lm-red`}>
                  {d.getDate()}
                </button>
                <span className="text-[9px] text-ink-soft">{busy}/{totalUnits}</span>
              </div>
              <div className="mt-1 space-y-1">
                {items.slice(0, 3).map((e) => <Chip key={e.key} ev={e} />)}
                {items.length > 3 && (
                  <button onClick={() => onPickDay(d)} className="text-[10px] text-lm-red hover:underline"
                    data-testid={`cal-more-${day}`}>+{items.length - 3} lagi</button>
                )}
              </div>
              <button onClick={() => onQuickAdd(day)} title="Booking manual di tanggal ini"
                data-testid={`cal-quick-add-${day}`}
                className="absolute bottom-1 right-1 hidden h-6 w-6 items-center justify-center rounded-full bg-ink text-cream group-hover:flex">
                <Plus size={13} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
